import { render, staticRenderFns } from "./EventAdminDuplicates.vue?vue&type=template&id=3b87deac"
import script from "./EventAdminDuplicates.js?vue&type=script&lang=js&external"
export * from "./EventAdminDuplicates.js?vue&type=script&lang=js&external"
import style0 from "./EventAdminDuplicates.vue?vue&type=style&index=0&id=3b87deac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports